import { MarketingNav, Footer } from "@/components/marketing/MarketingNav";
import { AurumOrb } from "@/components/brand/AurumOrb";

export default function About() {
  return (
    <div className="bg-[var(--bg)] text-[var(--text)] min-h-screen">
      <MarketingNav />
      <section className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-20">
        <AurumOrb status="IDLE" size={72} />
        <span className="mt-6 block text-xs uppercase tracking-wider text-aurum font-medium">About</span>
        <h1 className="mt-2 text-4xl lg:text-5xl font-extrabold tracking-tight">Trade the plan. Not the emotion.</h1>
        <div className="mt-6 space-y-4 text-[var(--text-sec)]">
          <p>Aurum AI was built on a simple belief: most trading damage is self-inflicted. Chasing, revenge trading, oversized risk, and abandoning a plan mid-trade cost more than any missed setup ever could.</p>
          <p>So we didn't build a signal bot. We built a disciplined copilot — one that watches XAU/USD continuously, applies <span className="text-[var(--text)]">your</span> rules, calculates risk before action, actively argues against weak trades, and is happy to tell you to do nothing.</p>
          <p>The heavy calculations are deterministic and transparent. The AI layer explains, teaches and challenges — but never invents a number, and never promises profits. You can always see exactly how Aurum reached a conclusion.</p>
          <p className="text-[var(--text-muted)] text-sm">Trading involves substantial risk of loss and is not suitable for everyone. Aurum AI is an educational and process-discipline tool, not financial advice.</p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
